import { forEach } from 'lodash';
import anime from 'animejs';

export default class SidebarNav {
  constructor(root) {
    this.root = root;
    this.items = this.root.querySelectorAll('li.has-children');
    this.init()
  }

  init() {
    this.onClick = this.click.bind(this);

    forEach(this.items, (item) => {
      item.querySelector('.u-nav-sidebar__link').addEventListener('click', this.onClick);
    });
  }

  click(e) {
    e.preventDefault();
    const item = e.target.parentNode;

    if (item.classList.contains('is-open')) {
      this.close(item);
    } else {
      this.closeAll()
      this.open(item);
    }
  }

  open(item) {
    console.info('open', item);
    item.classList.add('is-open');

    const list = item.querySelector('.u-nav-sidebar__list__list');
    const clone = list.cloneNode(true);
    clone.style.height = 'auto';
    clone.style.opacity = 0;
    this.root.appendChild(clone);
    const h = clone.offsetHeight;
    this.root.removeChild(clone);

    const anim = anime({
      targets: list,
      height: h,
      duration: 500,
      easing: 'easeOutExpo',
    });
  }

  close(item) {
    console.info('close', item);
    item.classList.remove('is-open');

    const list = item.querySelector('.u-nav-sidebar__list__list');
    const anim = anime({
      targets: list,
      height: 0,
      duration: 250,
      easing: 'easeOutExpo',
    });
  }

  closeAll() {
    forEach(this.items, (item) => {
      if (item.classList.contains('is-open')) {
        this.close(item);
      }
    });
  }

  destroy() {
    forEach(this.items, (item) => {
      item.removeEventListener('click', this.onClick);
    });
  }
}
